module.exports = {
  SERVICE: 'service',
  PACKAGE: 'package',
  GROUP: 'group'
}
